class RmcfTraditionsVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.inView = false;
    this.hovered = false;
    this.hoverMedia = window.matchMedia('(hover: hover)');
    this.onEnter = () => { if (this.hoverMedia.matches) { this.hovered = true; this.updatePlayback(); } };
    this.onLeave = () => { this.hovered = false; this.updatePlayback(); };
    this.addEventListener('pointerenter', this.onEnter);
    this.addEventListener('pointerleave', this.onLeave);
    this.userPaused = false;
    this.manualPlayback = false;
    this.autoPlayPending = false;
    this.onPause = () => {
      if (this.automaticPause) {
        this.automaticPause = false;
      } else if (this.inView && !document.hidden) {
        this.userPaused = true;
      }
    };
    this.onPlay = () => {
      if (!this.autoPlayPending) {
        this.manualPlayback = true;
        this.userPaused = false;
      }
    };
    this.onVisibility = () => this.updatePlayback();
    this.onMotion = () => {
      this.manualPlayback = false;
      this.updatePlayback();
    };
    this.video.addEventListener('pause', this.onPause);
    this.video.addEventListener('play', this.onPlay);
    document.addEventListener('visibilitychange', this.onVisibility);
    this.motion.addEventListener('change', this.onMotion);
    // Keep the poster if viewport observation is unavailable.
    if (!('IntersectionObserver' in window)) return;
    this.observer = new IntersectionObserver((entries) => {
      this.inView = entries[0].isIntersecting;
      this.updatePlayback();
    }, { threshold: 0.1 });
    this.observer.observe(this);
  }

  updatePlayback() {
    const canPlay = this.inView && !document.hidden && !this.userPaused && !this.hovered
      && (this.manualPlayback || (!this.motion.matches && !navigator.connection?.saveData));
    if (!canPlay) {
      if (!this.video.paused) {
        this.automaticPause = true;
        this.video.pause();
      }
      return;
    }
    if (!this.video.paused || this.autoPlayPending) return;
    this.autoPlayPending = true;
    this.video.play().catch(() => {
      // Autoplay can be blocked; leave the poster visible.
      if (this.inView && !document.hidden) this.userPaused = true;
    }).finally(() => {
      this.autoPlayPending = false;
      if (this.isConnected) this.updatePlayback();
    });
  }

  disconnectedCallback() {
    this.removeEventListener('pointerenter', this.onEnter);
    this.removeEventListener('pointerleave', this.onLeave);
    this.observer?.disconnect();
    this.video?.pause();
    this.video?.removeEventListener('pause', this.onPause);
    this.video?.removeEventListener('play', this.onPlay);
    document.removeEventListener('visibilitychange', this.onVisibility);
    this.motion?.removeEventListener('change', this.onMotion);
  }
}

if (!customElements.get('rmcf-traditions-video')) {
  customElements.define('rmcf-traditions-video', RmcfTraditionsVideo);
}
